import React from "react";

const FormPrintView = React.forwardRef(({ title, fields = [] }, ref) => {
  return (
    <div id="printt" ref={ref}>
      <h3 className="form-print-title">{title}</h3>
      <div className="form-print-fields">
        {fields.map((field, index) => (
          <p key={`${field.label}-${index}`}>
            <span>{field.label}: </span>
            {field.value ?? ""}
          </p>
        ))}
      </div>
    </div>
  );
});

FormPrintView.displayName = "FormPrintView";

export default FormPrintView;
